import React from 'react';
import PropTypes from 'prop-types';
import classes from './Button.module.scss';
import Loading from './loading/Loading';

function ButtonFilter(props) {
    const {
        title,
        variant = 'contained',
        onClick = () => { },
        children,
        color = 'blue',
        startIcon = null,
        endIcon = null,
        disabled = false,
        type = 'button',
        backgroundTransparent = false,
        size = 'nomarl',
        className = '',
        loading = false
    } = props;
    // variant : outlined | contained
    // color : gray | default | green | red | violet |
    // size : small | normal | large
    const getColor = (_color) => {
        if (_color == 'default') {
            return 'button_color_default';
        }
        if (_color == 'red') {
            return 'button_color_red';
        }
        if (_color == 'gray') {
            return 'button_color_gray';
        }
        if (_color == 'yellow') {
            return 'button_color_yellow';
        }
        if (_color == 'green') {
            return 'button_color_green';
        }
        if (_color == 'white') {
            return 'button_color_white';
        }
        if (_color == 'hippie_blue') {
            return 'button_color_hippie_blue';
        }
        if (_color == 'transparent') {
            return 'button_color_transparent';
        }
        return '';
    };

    return (
        <div
            className={`
            ${classes['custom-button']} ${classes['custom-button-filter']} ${classes[getColor(color)]} 
            ${backgroundTransparent ? classes['background-transparent'] : ''} ${disabled ? classes['disabled'] : ''} ${loading ? classes['disabled'] : ''} ${classes[size]} ${!children && !title ? classes['custom-button-icon'] : ''} ${className}`}
            style={{
                maxWidth: 300
            }}
        >
            <button
                className={`${classes[variant]}`}
                type={type}
                onClick={onClick}
                disabled={disabled ? disabled : (loading ? true : false)}
            >
                {loading ? (
                    <div className={`${classes['icon-button']} ${classes['icon-button-loading']}`}><Loading /></div>
                ) : null}
                {!loading && startIcon && (
                    <div className={classes['icon-button']}>{startIcon}</div>
                )}{' '}
                {
                    title && <span>{title}</span>
                }
                {
                    children && <div className={classes['common-display']}>{children}</div>
                }
                {endIcon && (
                    <div className={classes['icon-button']}>{endIcon}</div>
                )}
            </button>
        </div>
    );
}
ButtonFilter.propTypes = {
    title: PropTypes.string,
    variant: PropTypes.string,
    onClick: PropTypes.func,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    startIcon: PropTypes.element,
    endIcon: PropTypes.element,
    type: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.string,
    backgroundTransparent: PropTypes.bool,
    loading: PropTypes.bool,
};
export default ButtonFilter;
